import BlankDocuments from "./blankDocuments"

export default BlankDocuments
